export class ChangeControlLibraryConstants {
  public static readonly ChangeControlLibraryTitle = 'Change Register';

  public static readonly ChangeControl_Menu_General_Tab_Index: number = 0;
  public static readonly ChangeControl_Menu_File_Tab_Index: number = 1;
  public static readonly ChangeControl_Menu_RelatedDocoument_Tab_Index: number = 2;
  // confirmation Messages
  public static readonly ChangeControl_Slider_Confirmation_Header: string =
    'Confirmation';
  public static readonly ChangeControl_Slider_Confirmation_Text: string =
    'Any unsaved change will be lost when closing the screen. Do you want to continue?';

  //error Messages
  public static readonly ChangeControl_Page_Validation: string =
    'You do not have access to this page.';

  public static readonly RelatedDocuments_Self_Linking_ErrorMessage: string =
    'It is not possible to link a Document to itself';
  public static readonly RelatedDocuments_Already_Linked_With_Single_DocumentNumber_ErrorMessage: string =
    'The Document Document_Number is already a Related Document,it is not possible to add it again.';
  public static readonly RelatedDocuments_Already_Linked_With_Multi_DocumentNumbers_ErrorMessage: string =
    'The Documents Document_Numbers is already part of Related Documents,it is not possible to add it again.';

  //Toaster mesages
  public static readonly Severity_Success: string = 'success';
  public static readonly Severity_Info: string = 'info';
  public static readonly Severity_Err: string = 'error';
  public static readonly Severity_Warning: string = 'warn';
  public static readonly ChangeControl_Created_Success: string =
    'Change Control Created Successfully';
  public static readonly ChangeControl_Updated_Success: string =
    'Change Control Updated Successfully';
    public static readonly ChangeControl_Creation_Failed: string =
    'Due to some technical isssue, the change control was not saved. Please try again.';

  //Spinner Messages
  public static readonly ChangeControl_Save_InProgress: string =
    'Change Register Save is in progress';

  public static readonly ChangeControl_Update_InProgress: string =
    'Change Register Update is in progress';

  //Tooltip messages
  public static readonly ChangeControl_InfoForRiskAssessment: string =
    'If a Risk Assessment is required, follow the applicable local procedure.'
  public static readonly ChangeControl_InfoForclientNotificationOrApprovalRequired: string =
    'If a Client Notification/Approval is required, select an Internal Client Contact and follow the applicable local procedure.'
  public static readonly RelatedDocuments_Not_Aligned_With_Scope_ConfirmationMessage: string =
    `This Related Document is associated 
    with a different eQMS Scope than the current Change Control. Users may not be able to view this Related 
    Document based on their particular eQMS Scope access. Do you wish to continue and link the Related Document?`;

  //Form Validation messages
  // Error Messages

  public static readonly ChangeControl_ErrorText: string = 'Please correct the following errors to save the Change Management.';
  public static readonly ChangeControl_Title_Required: string = 'Title is required.';
  public static readonly ChangeControl_Priority_Required: string = 'Priority is required.';
  public static readonly ChangeControl_Reason_Required: string = 'Reason is required.';
  public static readonly ChangeControl_Impact_Required: string = 'Impact Area is required.';
  public static readonly ChangeControl_Category_Required: string = 'Category is required.';
  public static readonly ChangeControl_eQMSScope_Required: string = 'eQMS Scope(s) is required.';
  public static readonly ChangeControl_ChangeRequestSource_Required: string = 'Change Request Source is required.';
  public static readonly ChangeControl_CurrentState_Required: string = 'Current State Area is required.';
  public static readonly ChangeControl_FutureState_Required: string = 'Future State is required.';
  public static readonly ChangeControl_Rationale_Required: string = 'Rationale is required.';
  public static readonly ChangeControl_TargetCompletionDate_Required: string = 'Target Completion Date is required.';
  public static readonly ChangeControl_Collaborators_Required: string = 'Collaborators(s) is required.';
  public static readonly ChangeControl_ImplementationOwners_Required: string = 'Implementation Owners(s) is required.';
  public static readonly ChangeControl_Reviewers_Required: string = 'Reviewer(s) is required.';
  public static readonly ChangeControl_Approvers_Required: string = 'Approver(s) is required.';
  public static readonly ChangeControl_Verifiers_Required: string = 'Verifiers(s) is required.';
  public static readonly ChangeControl_InternalClientContact_Required: string = 'Internal Client Contact is required.';
  public static readonly ChangeControl_ApproverReviewerValidation_ErrorMessage: string = 'The Reviewer and Approver fields cannot be exactly the same.';


  //ChangeControl tabs constants


  public static readonly Attachment_File_Max_Size: number = 100;
  public static readonly Attachments_File_Types: string =
    '.pdf, .xls, .xlsx, .xlsm, .doc, .docx, .docm, .ppt, .pptx, .txt, .jpeg, .png, .zip, .7z'

  public static readonly ChangeControl_Attachments_FolderName = 'eqmsactionitemattachments';

  public static readonly ChangeControl_File_Attachments_Header_Text: string =
    'Attachments are files that are not directly managed in eQMS. These attachments are available to Users from the Change Control Details and should be used as additional information, if necessary.';

  public static readonly Deleted_Attachments_Confirmation_Message: string =
    'You are about to delete the following attachments. This action is not reversible. Do you want to proceed?'

  public static readonly File_Upload_Failed: string = 'A Technical error occurred and the Name was not uploaded. Please contact technical support.'
  public static readonly ChangeControlAttachments: string = 'Change Control Attachment(s)'

  public static readonly ChangeControlRelatedDocumentsTab: string = 'Change Control Related Documents'

  public static readonly SourceForScopes_From_Manage: string ='manage';

   public static readonly ReasonValidationMessage : string ='Reason is required';
     public static readonly ReasonHeading : string ='Reason for Change';

}
